/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { REGULAR_DRIVER, MARITAL_STATUS, PORTABLE_POSSESSIONS_RISK } from '../../../routes/routes';
import './RegularDriverOther.css';
import { ProgressBar, Form, Button, Dropdown, Image } from 'react-bootstrap';
import { validateName, validateSurname, validateIdNumber } from '../../../constants/validation';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { postRegularDriverFlow, setRegularDriverOther } from '../../../actions/salesActions';
import { PRODUCT_BLING } from '../../../constants/constants';


class RegularDriverOther extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            firstname: '',
            surname: '',
            idnumber: '',
            relationshipList: [],
            selectedRelationship: '',
            selectedRelationshipDropdown: false,
            submitted: false,
            nameRegex: true,
            surnameRegex: true,
            idnumberRegex: true,
            nextDisabled: true,
            loggedIn: this.props.auth.uid ? true : false,
            isMale: null,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleRelationshipSelection = this.handleRelationshipSelection.bind(this);
        this.handleRelationshipDropdownToggle = this.handleRelationshipDropdownToggle.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMaleClick = this.handleMaleClick.bind(this);
        this.handleFemaleClick = this.handleFemaleClick.bind(this);
    }

    async componentDidMount() {
        if (this.state.relationshipList.length === 0) {
            this.getRelationship();
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        await this.checkSubmit();
    }

    async checkSubmit() {
        const { firstname } = this.state;
        const { surname } = this.state;
        const { idnumber } = this.state;
        const { selectedRelationship } = this.state;
        if (this.props.profile.countryId === 157) {
            if (idnumber.length === 11 && this.state.isMale !== null) {
                if (validateName.test(firstname) && validateSurname.test(surname) && selectedRelationship) {
                    await this.setState({ nextDisabled: false });
                } else {
                    await this.setState({ nextDisabled: true });
                }
            }
        }
        else if(validateIdNumber.test(idnumber)) {
            if (validateName.test(firstname) && validateSurname.test(surname) && selectedRelationship) {
                await this.setState({ nextDisabled: false });
            } else {
                await this.setState({ nextDisabled: true });
            }
        }
    }

    async handleBack(e: any) {
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.dispatchRedirectTo(REGULAR_DRIVER)
        }
        else {
            this.props.dispatchRedirectTo(REGULAR_DRIVER)
        }
    }

    handleRedirect(nextPage: string) {
        this.props.dispatchRedirectTo(nextPage);
    }

    async getRelationship() {
        await postToController(this.props.dispatch, 'GetRelationshipSelection', JSON.stringify({})).then(async (response) => {
            await this.setState({ relationshipList: response });
            return true;
        })
    }

    async handleBlur(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "firstname") {
            var valid = validateName.test(value)
            await this.setState({ nameRegex: valid });
        } else if (name === "surname") {
            var valid = validateSurname.test(value)
            await this.setState({ surnameRegex: valid });
        } else if (name === "idnumber" && this.props.profile !== 157) {
            var valid = validateIdNumber.test(value)
            await this.setState({ idnumberRegex: valid });
        }
        else if (name === "idnumber") {
            await this.setState({ idnumberRegex: true });
        }
    }

    async handleRelationshipSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let coverItem = this.state.relationshipList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedRelationship: coverItem[0] });
        await this.checkSubmit();
    }

    async handleRelationshipDropdownToggle(e: any) {
        await this.setState({
            selectedRelationshipDropdown: !this.state.selectedRelationshipDropdown
        });
    }

    handleClick() {
        this.props.dispatchSetRegularDriverOther(this.state.firstname, this.state.surname, this.state.idnumber, this.state.selectedRelationship, this.state.isMale)
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.dispatchRedirectTo(PORTABLE_POSSESSIONS_RISK)
        }
        else {
            this.props.dispatchRedirectTo(MARITAL_STATUS)
        }
    }

    async handleMaleClick() {
        await this.setState({ isMale: true });
        await this.checkSubmit();
    }

    async handleFemaleClick() {
        await this.setState({ isMale: false });
        await this.checkSubmit();
    }

    public render() {
        let relationshipDrop = [];
        if (this.state.relationshipList.length > 0) {
            relationshipDrop = this.state.relationshipList.filter(item => item.description !== "Insured").map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id}>{item.description}</Dropdown.Item>
            });
        }
        const { firstname, surname, idnumber, submitted, nameRegex, surnameRegex, idnumberRegex, hide } = this.state;
        const quoteType = this.props.sales.quoteType;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={55} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        {quoteType !== "PRODUCT_BLING" ? <div className="ssp-regular-driver-user-other-main-contentholder mt-21px mobile-mt-17px mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="font-size-16px font-weight-500 line-height-normal">Please fill in the driver's details below</div>
                                        </div> : <div className="ssp-regular-driver-user-other-main-contentholder-bling mt-21px mobile-mt-17px mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="font-size-16px font-weight-500 line-height-normal">Please fill in the details of the person who uses this phone (aka the regular cellphone user)</div>
                                        </div>}
                                        <div className="row noma regular-form-container">
                                            <div className="col-12 nopa form-row noma ssp-addreplacement-value-tile-holder-row mobile-mb-0px mb-20px">
                                                <div className="col-12 col-lg-6 nopa mobile-mb-20px">
                                                    <div className={'form-group mb-0px mr-20px mobile-mr-0px' + (submitted && !firstname ? ' has-error' : '')}>
                                                        <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.firstname !== "" ? "" : " no-opacity")}>Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Name" id="PersonalInputName" name="firstname" value={this.state.firstname} onChange={this.handleChange} onBlur={this.handleBlur} />
                                                        <div className="help-block">
                                                            {!nameRegex ? <div>First name must be 3 characters or more</div> : null}
                                                        </div>
                                                        {submitted && !firstname &&
                                                            <div className="help-block">First name is required</div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 nopa mobile-mb-20px">
                                                    <div className={'form-group mb-0px' + (submitted && !surname ? ' has-error' : '')}>
                                                        <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.surname !== "" ? "" : " no-opacity")}>Surname</Form.Label>
                                                        <Form.Control type="text" placeholder="Surname" name="surname" value={this.state.surname} onChange={this.handleChange} onBlur={this.handleBlur} />
                                                        <div className="help-block">
                                                            {!surnameRegex ? <div>Surname name must be 3 characters or more</div> : null}
                                                        </div>
                                                        {submitted && !surname &&
                                                            <div className="help-block">Surname is required</div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 nopa form-row noma ssp-addreplacement-value-tile-holder-row">
                                                <div className="col-12 col-lg-6 nopa mobile-mb-20px">
                                                    <div className={'form-group mb-0px mr-20px mobile-mr-0px' + (submitted && !idnumber ? ' has-error' : '')}>
                                                        <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.idnumber !== "" ? "" : " no-opacity")}>ID no.</Form.Label>
                                                        <Form.Control type="text" placeholder="ID no." name="idnumber" value={this.state.idnumber} onChange={this.handleChange} onBlur={this.handleBlur} />
                                                        <div className="help-block">
                                                            {!idnumberRegex ? <div>Please give a valid ID number.</div> : null}
                                                        </div>
                                                        {submitted && !idnumber &&
                                                            <div className="help-block">ID no. is required</div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 nopa">
                                                    <div className="form-group mb-0px">
                                                        <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.selectedRelationship !== "" ? "" : " no-opacity")}>Relationship to policyholder</Form.Label>
                                                        <Dropdown
                                                            id="financeHouse-select-dropdown"
                                                            className="fit-full"
                                                            onSelect={this.handleRelationshipSelection}
                                                            onToggle={this.handleRelationshipDropdownToggle}>
                                                            <Dropdown.Toggle id="dropdown-basic">
                                                                <div className="row dropdown-height">
                                                                    <div className="dropdown-basic-title-text col-11">
                                                                        {this.state.selectedRelationship.description}
                                                                        {!this.state.selectedRelationship &&
                                                                            <p>Relationship to policyholder</p>
                                                                        }
                                                                    </div>
                                                                    <Image src='Images/Bling/Dropdownup.svg' className={this.state.selectedRelationshipDropdown ? 'visible' : 'invisible'} alt="" />
                                                                    <Image src='Images/Bling/Dropdown.svg' className={this.state.selectedRelationshipDropdown ? 'invisible' : 'visible'} alt="" />
                                                                </div>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu id='financeHouseDropDown'>
                                                                {relationshipDrop}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.props.profile.countryId === 157 &&
                                            <div className="form-row mb-lg-1 mb-2 text-center">
                                                <div className="col-12">
                                                    <div className={'form-group' + (submitted && this.state.isMale === null ? ' has-error' : '')}>
                                                        <Form.Check name="group1" inline type="radio" label="Male" id="MaleRadio" onChange={this.handleMaleClick} />
                                                        <Form.Check name="group1" inline type="radio" label="Female" id="FemaleRadio" onChange={this.handleFemaleClick} />
                                                        {submitted && this.state.isMale === null &&
                                                            <div className="help-block">Gender is required</div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-12 col-lg-4 nopa regular-other-button-holder">
                                                <button type="submit" className="btn btn-block btn-solid-red button-width cursor-pointer" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchPostRegularDriver: () => dispatch(postRegularDriverFlow()),
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetRegularDriverOther: (name: any, surname: any, idnumber: any, selectedRelationship: any, isMale: any) => dispatch(setRegularDriverOther(name, surname, idnumber, selectedRelationship, isMale))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegularDriverOther);